<aside class="generating-animation" [ngClass]="{'generating' : generating, 'disable-hover' : disableHover, 'success' : success, 'failed' : failed}">
  <span class="star"></span>
  <span class="star"></span>
  <span class="star"></span>
</aside>
